import styled from 'styled-components';

const SettingsSelect = styled.select`
  height: 40px;
  width: 225px;
  flex-grow: 1;
  margin: 0;
`;

export default SettingsSelect;
